module.exports = __webpack_public_path__ + "img/logo_uhl.d24ecdd0.png";